import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {environment} from '@env/environment';
import {IsMasterOrAdminUserGuard} from '../../../../guards/is-master-or-admin-user.guard';

@Injectable({providedIn: 'root'})
export class JugBillingOnlyGuard implements CanActivate {

    constructor(
        private router: Router,
        private masterOrAdminUserGuard: IsMasterOrAdminUserGuard
    ) {
    }

    canActivate(): boolean | UrlTree | Promise<boolean> {
        const isJugEnvironment = !environment.pool && environment.customer?.toLowerCase() === 'jug';

        return isJugEnvironment
            ? this.router.createUrlTree(['/abonnement/zahlungskonto'])
            : this.masterOrAdminUserGuard.checkIfMasterOrAdminUser();
    }
}
